import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AppTermsAndConditionsService {
  private readonly consentCookieName = 'Accepted Terms&conditions';

  constructor(private cookieService: CookieService) {}

  getConsentCookie(): string {
    return this.cookieService.get(this.consentCookieName);
  }

  setConsentCookie(): void {
    this.cookieService.set(this.consentCookieName, 'true', 365); // Set an expiration of 365 days
  }

  clearConsentCookie(): void {
    this.cookieService.set(this.consentCookieName, 'false', 365);
  }
}
